// extracted by css-extract-rspack-plugin
export default {"icon":"DeleteColumn__icon--Squ04","attention":"DeleteColumn__attention--r3LPX"};